import CompositeCheckbox from './composite-checkbox';
import './composite-checkbox.scss';

export default CompositeCheckbox;
